const AccessToken = {
  token: true,
  actor: {
    id: true,
    roles: true,
    __on: {
      __typeName: "Employee",
      phone: true
    }
  },
  createdAt: true,
  expiresAt: true
};

export default AccessToken;